/**
 * État UI global - signal observable.
 * Contient : onglet courant, filtres, recherche globale, thème, etc.
 */

import { signal } from './signal';

export type ThemeId = 'dark' | 'light';

const THEME_KEY = 'cof2:theme';

/**
 * Thème courant (dark par défaut). Persisté en localStorage.
 */
export const themeSignal = signal<ThemeId>(loadTheme());

themeSignal.subscribe((t) => {
  document.documentElement.setAttribute('data-theme', t);
  try {
    localStorage.setItem(THEME_KEY, t);
  } catch {
    // localStorage indisponible (mode privé, test Node) - ignoré
  }
});

/**
 * Applique le thème initial sur <html> dès le chargement.
 */
export function applyInitialTheme(): void {
  document.documentElement.setAttribute('data-theme', themeSignal.get());
}

function loadTheme(): ThemeId {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    // pas de localStorage
  }
  return 'dark';
}

/**
 * Bascule le thème (toggle).
 */
export function toggleTheme(): void {
  themeSignal.set(themeSignal.get() === 'dark' ? 'light' : 'dark');
}
